import { enUS as userGroupsTranslations } from '../UserGroup/en-US';
import type { IGroupsTranslations } from '@/Pages/Groups/types/groupsTranslations.types';

const enUS: IGroupsTranslations = {
  route: 'Groups',
  chooseGroup: {
    title: 'Create Groups',
    description: 'Select the type of group you want to create.',
    cards: {
      devices: {
        title: 'Devices',
        description:
          'Create device groups to help you segment or categorize according to your requirements.',
      },
      users: {
        title: 'Users',
        description:
          'Create user groups to help you segment which users will be able to view certain devices.',
      },
    },
  },
  modals: {
    newGroupAssignment: {
      title: 'Do you want to assign it to a new user group?',
      description: 'You will be taken to the process of creating a new group.',
      cancelButton: 'No',
      confirmButton: 'Yes',
    },
    deviceGroupLink: {
      title: 'Attention!',
      description:
        'To ensure the proper functioning of this new group, it is important to link it to a device group. Do you want to make this association now?',
      cancelButton: 'No',
      confirmButton: 'Yes',
    },
    redirecting: {
      title: 'You are being redirected to the group creation screen',
      description:
        "Don't worry, the settings you've already defined are saved, and you'll be able to review them later before finalizing the group creation.",
    },
  },
  overview: {
    title: 'Groups Overview',
    description: 'Check the parameters chosen for the groups.',
    groupData: {
      title: 'Group Data',
      groupName: 'Group Name:',
      groupDescription: 'Description:',
    },
    hierarchy: {
      title: 'Hierarchy',
      belongsTo: 'Will belong to the group:',
    },
    permissions: {
      title: 'Group Permissions',
      administrators: 'Administrators',
      viewers: 'View-only profiles',
    },
    devicesCount: {
      title: 'Devices',
    },
    assignedGroups: {
      assignOne: {
        title: 'Assigned group 1',
      },
      assignTwo: {
        title: 'Assigned group 2',
      },
      groupName: 'Group Name',
      description: 'Description',
      users: 'Users',
      user: 'user',
      permissions: {
        label: 'Group permissions',
        administrators: 'Administrators:',
        viewers: 'View-only profiles:',
      },
    },
    submitButton: 'Done',
  },
  userGroups: userGroupsTranslations,
};

export { enUS };
